// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.bs.mjs";
import * as Core__Option from "@rescript/core/lib/es6/src/Core__Option.bs.mjs";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Modal$LumiFacilityInfo from "lumi-facility-info/lib/es6/src/Modal.bs.mjs";
import * as Translation$LumiFacilityInfo from "lumi-facility-info/lib/es6/src/Translation.bs.mjs";

function CarFacilityList$Facility(props) {
  var dynamicData = props.dynamicData;
  var staticData = props.staticData;
  var match = React.useState(function () {
        return false;
      });
  var setShowModal = match[1];
  var name = Core__Option.getOr(Core__Option.map(dynamicData, (function (dd) {
              return dd.name;
            })), staticData.name);
  var address = Core__Option.map(staticData.addresses[0], (function (a) {
          return a.streetName + " " + a.houseNumber + ", " + a.city;
        }));
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                match[0] ? JsxRuntime.jsx(Modal$LumiFacilityInfo.make, {
                        name: name,
                        website: "https://www.nijmegen.nl/diensten/parkeren-verkeer-en-vervoer/parkeergarages/",
                        address: address,
                        close: (function () {
                            setShowModal(function (param) {
                                  return false;
                                });
                          })
                      }) : null,
                JsxRuntime.jsxs("a", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h1", {
                                      children: name,
                                      className: "is-size-5 is-family-primary"
                                    }),
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        LumiReact.renderOption(undefined, address, (function (prim) {
                                                return prim;
                                              })),
                                        JsxRuntime.jsx("br", {}),
                                        LumiReact.renderOption(undefined, dynamicData, (function (dd) {
                                                return JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                                            entry: {
                                                              TAG: "Capacity",
                                                              _0: dd.capacity
                                                            }
                                                          });
                                              })),
                                        JsxRuntime.jsx("br", {})
                                      ],
                                      className: "is-size-6"
                                    })
                              ],
                              className: "facility-item-text has-text-grey-lighter"
                            }),
                        LumiReact.renderOption(undefined, dynamicData, (function (dd) {
                                return JsxRuntime.jsx("div", {
                                            children: dd.isOpen ? (
                                                dd.isFull ? JsxRuntime.jsx("p", {
                                                        children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                                              entry: {
                                                                TAG: "FacilityState",
                                                                _0: "Full"
                                                              }
                                                            }),
                                                        className: "facility-status-bad is-size-2"
                                                      }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                        children: [
                                                          JsxRuntime.jsx("p", {
                                                                children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                                                      entry: "FreePlaces"
                                                                    }),
                                                                className: "facility-status-ok is-size-6"
                                                              }),
                                                          JsxRuntime.jsx("p", {
                                                                children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                                                      entry: {
                                                                        TAG: "FacilityState",
                                                                        _0: {
                                                                          TAG: "Free",
                                                                          _0: dd.vacantSpaces
                                                                        }
                                                                      }
                                                                    }),
                                                                className: "facility-status-ok is-size-2"
                                                              })
                                                        ]
                                                      })
                                              ) : JsxRuntime.jsx("p", {
                                                    children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                                          entry: {
                                                            TAG: "FacilityState",
                                                            _0: "Closed"
                                                          }
                                                        }),
                                                    className: "facility-status-bad is-size-2"
                                                  }),
                                            className: "facility-item-message-box"
                                          });
                              }))
                      ],
                      className: "facility-item car-facility-item",
                      onClick: (function (param) {
                          setShowModal(function (param) {
                                return true;
                              });
                        })
                    })
              ]
            });
}

var Facility = {
  make: CarFacilityList$Facility
};

function CarFacilityList(props) {
  var carFacilityDynamicData = props.carFacilityDynamicData;
  var facilities = Belt_MapString.toArray(props.carFacilityStaticData).map(function (param) {
        var identifier = param[0];
        return [
                identifier,
                param[1],
                Belt_MapString.get(carFacilityDynamicData, identifier)
              ];
      });
  return JsxRuntime.jsx("div", {
              children: facilities.map(function (param) {
                    return JsxRuntime.jsx(CarFacilityList$Facility, {
                                staticData: param[1],
                                dynamicData: param[2]
                              }, param[0]);
                  }),
              className: "facility-list-section"
            });
}

var GM;

var T;

var make = CarFacilityList;

export {
  GM ,
  T ,
  Facility ,
  make ,
}
/* react Not a pure module */
